export const contactsData = {
    email: 'simrat.luvn.100@gmail.com',
    phone: '+91 7209803944',
    address: 'RAMANDEEP COLONY, 33-FOOT ROAD, LUDHIANA, PUNJAB, 141015',
    map:'https://www.google.com/maps/place/33+Feet+Rd,+Punjab/@30.9040705,75.9290992,13z/data=!4m5!3m4!1s0x391a9cdf06cd55e9:0x74001cc5e3863e5a!8m2!3d30.9002763!4d75.9315027',

    sheetAPI: 'https://sheetdb.io/api/v1/y8yhmsr9qlqe0'
}